import React, { Fragment } from "react";

import { classNameGenerator } from "@/utils";

import Typography from "@/foundation/Typography/V2";

import styles from "./Breadcrumb.module.scss";

interface BreadcrumbProps {
  items: {
    title: string;
    link?: string;
  }[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  const cls = classNameGenerator(styles);

  return (
    <div className={cls("breadcrumbWrapper")}>
      {items?.map(({ title, link }, index) => (
        <Fragment key={index}>
          {index !== 0 && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              className={cls("icon")}
            >
              <path
                d="M4.74304 2.70715L8.13126 6.09537L4.74304 9.48359"
                stroke="#282828"
                strokeWidth="1.5"
                strokeLinecap="square"
              />
            </svg>
          )}
          <Typography
            className={cls("title")}
            variant={link ? "link1" : "paragraph1"}
            {...(link ? { href: link } : {})}
          >
            {title}
          </Typography>
        </Fragment>
      ))}
    </div>
  );
};

export default Breadcrumb;
